// Loading.js
import React from "react";
import styled, { keyframes } from "styled-components";

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(247, 247, 247, 0.65);
  backdrop-filter: blur(12px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

const FloatingSvg = styled.div`
  width: 20rem;
  height: auto;
  overflow: visible;
  margin-right: 0rem;

  svg {
    width: 100%;
    height: auto;
  }

  path {
    animation: ${float} 3s ease-in-out infinite;
    transform-origin: center;
  }

  /* path 딜레이 */
  path:nth-child(1) { animation-delay: 0s; }
  path:nth-child(2) { animation-delay: 0.2s; }
  path:nth-child(3) { animation-delay: 0.4s; }
  path:nth-child(4) { animation-delay: 0.6s; }
  path:nth-child(5) { animation-delay: 0.8s; }
  path:nth-child(6) { animation-delay: 1s; }
  path:nth-child(7) { animation-delay: 1.2s; }
  path:nth-child(8) { animation-delay: 0.2s; }
  path:nth-child(9) { animation-delay: 0.4s; }
  path:nth-child(10) { animation-delay: 0.6s; }
  path:nth-child(11) { animation-delay: 0.8s; }
  path:nth-child(12) { animation-delay: 1s; }
  path:nth-child(13) { animation-delay: 1.2s; }
  path:nth-child(14) { animation-delay: 0.2s; }
  path:nth-child(15) { animation-delay: 0.4s; }

  /* 💻 1440px 이하: SVG 조금 축소 */
  @media (max-width: 1440px) {
    width: 16rem;
    margin-right: 10rem;
  }

  /* 📱 모바일 */
  @media (max-width: 768px) {
    width: 14rem;
    margin-right: 0;
  }


`;


export default function Loading() {
  return (
    <Overlay>
      <FloatingSvg>
        <svg
          width="500"
          height="400"
          viewBox="0 0 500 306"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M216.835 224.279C218.449 224.279 219.758 222.97 219.758 221.356C219.758 219.742 218.449 218.434 216.835 218.434C215.221 218.434 213.913 219.742 213.913 221.356C213.913 222.97 215.221 224.279 216.835 224.279Z" fill="#A0354D"/>
          <path d="M76.2148 281.715C77.829 281.715 79.1375 280.407 79.1375 278.792C79.1375 277.178 77.829 275.87 76.2148 275.87C74.6007 275.87 73.2922 277.178 73.2922 278.792C73.2922 280.407 74.6007 281.715 76.2148 281.715Z" fill="#A0354D"/>
          <path d="M232.985 207.764C234.599 207.764 235.908 206.456 235.908 204.841C235.908 203.227 234.599 201.919 232.985 201.919C231.371 201.919 230.062 203.227 230.062 204.841C230.062 206.456 231.371 207.764 232.985 207.764Z" fill="#A0354D"/>
          <path d="M327.464 75.6285C329.078 75.6285 330.387 74.32 330.387 72.7059C330.387 71.0918 329.078 69.7833 327.464 69.7833C325.85 69.7833 324.542 71.0918 324.542 72.7059C324.542 74.32 325.85 75.6285 327.464 75.6285Z" fill="#A0354D"/>
          <path d="M353.897 48.4611C355.511 48.4611 356.82 47.1526 356.82 45.5384C356.82 43.9243 355.511 42.6158 353.897 42.6158C352.283 42.6158 350.975 43.9243 350.975 45.5384C350.975 47.1526 352.283 48.4611 353.897 48.4611Z" fill="#A0354D"/>
          <path d="M390.61 30.1046C392.224 30.1046 393.533 28.7961 393.533 27.182C393.533 25.5679 392.224 24.2594 390.61 24.2594C388.996 24.2594 387.688 25.5679 387.688 27.182C387.688 28.7961 388.996 30.1046 390.61 30.1046Z" fill="#A0354D"/>
          <path d="M475.05 5.84522C473.435 5.84522 472.127 4.53672 472.127 2.92261C472.127 1.3085 473.435 0 475.05 0C476.664 0 477.972 1.3085 477.972 2.92261C477.972 4.53672 476.664 5.84522 475.05 5.84522Z" fill="#A0354D"/>
          <path d="M497.077 5.87415C495.463 5.87415 494.155 4.56565 494.155 2.95154C494.155 1.33743 495.463 0.0289307 497.077 0.0289307C498.692 0.0289307 500 1.33743 500 2.95154C500 4.56565 498.692 5.87415 497.077 5.87415Z" fill="#A0354D"/>
          <path d="M107.343 278.792C108.957 278.792 110.265 277.484 110.265 275.87C110.265 274.256 108.957 272.947 107.343 272.947C105.728 272.947 104.42 274.256 104.42 275.87C104.42 277.484 105.728 278.792 107.343 278.792Z" fill="#A0354D"/>
          <path d="M137.769 272.947C139.383 272.947 140.692 271.639 140.692 270.025C140.692 268.411 139.383 267.102 137.769 267.102C136.155 267.102 134.846 268.411 134.846 270.025C134.846 271.639 136.155 272.947 137.769 272.947Z" fill="#A0354D"/>
          <path d="M173.142 258.037C174.756 258.037 176.064 256.729 176.064 255.115C176.064 253.501 174.756 252.192 173.142 252.192C171.528 252.192 170.219 253.501 170.219 255.115C170.219 256.729 171.528 258.037 173.142 258.037Z" fill="#A0354D"/>
          <path d="M314.036 115.349L321.127 111.787L323.276 110.48L324.229 109.582L325.228 107.372L325.632 106.604L326.737 105.599L321.705 97.6562L318.103 100.147L311.781 101.42L309.437 101.97L305.196 104.298L303.109 105.936L301.28 107.972L298.902 109.375L294.672 111.377L290.958 113.189L288.086 114.255L285.601 114.939L284.737 115.601L283.862 116.88L283.111 117.486L282.022 118.99L281.372 120.196L281.22 121.626L282.23 122.361L285.035 122.445L285.596 122.282L287.413 122.759L288.546 122.832L291.839 121.637L296.372 120.246L298.93 119.276L299.805 119.954L300.932 120.285L307.254 118.687L311.759 116.241L314.036 115.349Z" fill="#A0354D"/>
          <path d="M442.096 25.4741L439.465 26.0968L435.662 26.6802L429.171 28.7053L425.789 30.0628L414.121 19.6906L416.438 13.9576L419.349 11.3155L422.283 7.84873L425.722 3.67518L428.414 1.19573L429.205 0.93769L435.163 0.0850281L436.111 0.0289307L437.244 0.763791L439.347 0.348679L441.754 0.505749L443.268 1.30231L444.127 2.12132L446.118 2.10449L447.818 2.72155L449.428 4.20809L449.647 4.87003L451.582 5.11124L453.641 6.09853L454.179 6.66511L455.138 9.61576L453.629 12.443L448.637 15.0234L446.41 15.0571L445.613 14.1652L443.465 14.7037L442.696 17.357L442.898 18.1985L443.908 18.7314L448.042 19.4214L449.484 19.3933L452.306 18.8548L453.646 19.0792L456.3 21.2108L456.277 22.4842L456.002 23.5388L452.272 24.7505L449.843 25.2778L446.769 25.3507L442.096 25.4741Z" fill="#A0354D"/>
          <path d="M247.138 179.435H234.062L232.11 177.629L232.239 175.699L228.789 175.34L227.196 173.394L226.944 171.986L224.857 171.184L223.97 169.462L224.98 167.055L226.091 166.763L225.754 165.804L226.719 163.005L228.817 162.343H235.055L239.459 161.911L238.651 161.215L237.91 159.914L238.426 157.676L241.304 157.064L245.747 156.397L255.143 156.806L257.662 157.406L265.79 161.855L268.522 162.22L268.589 176.838L265.179 176.821L262.873 178.364L260.545 179.273L253.112 180.131L247.138 179.435Z" fill="#A0354D"/>
          <path d="M31.0885 305.539L35.8174 300.26L39.3514 299.178L41.4943 297.927L41.4494 294.522L40.1368 293.046L42.1675 289.041L42.2853 286.646L40.0414 284.688L36.9561 284.172L36.9225 284.077L41.6682 282.029L45.2472 280.15L48.7251 279.398L51.5019 277.889L51.9843 274.445L49.6451 273.144L44.9274 273.648L37.2422 276.554L27.7732 278.994L19.4822 283.016L10.5236 285.877L0 290.247L6.63617 303.57L9.0427 302.74L11.7073 302.577L13.6426 303.57L16.5428 304.221L20.6322 303.677L26.6849 302.375L27.201 304.288L29.0915 305.539H31.0885Z" fill="#A0354D"/>
        </svg>
      </FloatingSvg>
    </Overlay>
  );
}
